import styled from 'styled-components';

export default styled.div`
  position: relative;
  padding-left: 2rem;
`;
